import React from "react";
import { getCurrentYear } from "../utils/helpers";

const Footer = () => {
  return (
    <>
      {/* Footer */}
      <p className="copyright">
        © {getCurrentYear()} Caelius Consulting INC – All Rights Reserved
      </p>
    </>
  );
};

export default Footer;
